import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(3)
  },
  stockPhotosItem: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(2, 1.75)
  }
}))
